import { useNavigate } from "react-router-dom";
import { BackButton } from "../../styles/AddAdherense";
import {
  CancelCard,
  CancelPlansTitle,
  CancelPlanStyle,
  DeactivateButton2,
  LeftContent,
  Select,
  SelectionIndicator,
  WrapCards,
  WrapContent,
  WrapTitleAndSmallText,
} from "../../styles/CancelPlan";
import { HOME_LOGGED } from "../../core/app-urls";
import { useEffect, useState } from "react";
import { getContractsPF } from "../../data/services/person_service";
import { FaSearch } from "react-icons/fa";
import CancelModel from "../../data/models/cancel";
import {
  destroyContractCancelRequest,
  getListOfCancelationRequest,
} from "../../data/services/enterprise_service";
import { toast, ToastContainer } from "react-toastify";

export default function CancelRequest() {
  const [contracts, setContracts] = useState<any[]>([]);
  const [selectedContractId, setSelectedContractId] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [cancelRequests, setCancelRequests] = useState<CancelModel[]>([]);
  const [selectedCards, setSelectedCards] = useState<number[]>([]);
  const [hasSearched, setHasSearched] = useState<boolean>(false);
  const navigate = useNavigate();

  const fetchContracts = async () => {
    setLoading(true);
    const response = await getContractsPF();
    if (response.data) {
      setContracts(response.data);
    } else {
      console.error("Não foi possível carregar os contratos.");
    }
    setLoading(false);
  };

  const fetchCancelationData = async () => {
    if (!selectedContractId) return;
    setHasSearched(true);
    const { data } = await getListOfCancelationRequest(selectedContractId);
    setCancelRequests(data || []);
    setSelectedCards([]);
  };

  useEffect(() => {
    fetchContracts();
  }, []);

  const handleLogout = () => {
    navigate(HOME_LOGGED);
  };

  const toggleSelection = (id: number) => {
    setSelectedCards((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleDeactivate = async () => {
    if (selectedCards.length === 0) return;

    const selectedData = cancelRequests
      .filter((cancel) => selectedCards.includes(cancel.id))
      .map((cancel) => ({
        id_contrato: cancel.idContrato,
        motivo: 12,
        observacao: "",
      }));

    try {
      const response = await destroyContractCancelRequest(selectedData);
      if (response?.message) {
        toast.success(response.message);
      }else{
        toast.error("Ocorreu um erro ao tentar cancelar os planos.");
      }
      await fetchCancelationData();
    } catch (error) {
      console.error("Erro ao desativar selecionados", error);
    }
  };

  return (
    <CancelPlanStyle>
      <ToastContainer />
      <WrapContent>
        <BackButton onClick={handleLogout}>VOLTAR</BackButton>
        <WrapTitleAndSmallText>
          <CancelPlansTitle>
            Solicitações de cancelamento de planos
          </CancelPlansTitle>
          <p>
            Aqui você terá acesso aos pedidos de desativação e cancelamento de
            planos
          </p>
        </WrapTitleAndSmallText>

        <div style={{ display: "flex", flexDirection: "row" }}>
          <Select
            value={selectedContractId}
            onChange={(e) => {
              setSelectedContractId(e.target.value);
              setHasSearched(false);
            }}
          >
            <option value="">Selecione o número do contrato</option>
            {contracts.map((contract) => (
              <option key={contract.idContrato} value={contract.idContrato}>
                {contract.numero_contrato}
              </option>
            ))}
          </Select>
          <FaSearch
            size={20}
            style={{
              marginTop: "12px",
              marginLeft: "10px",
              color: "#005CA9",
              cursor: "pointer",
            }}
            onClick={fetchCancelationData}
          />
        </div>
        <WrapCards>
          {cancelRequests.length > 0 ? (
            cancelRequests.map((cancel, index) => (
              <CancelCard
                key={index}
                onClick={() => toggleSelection(cancel.id)}
                style={{
                  border: selectedCards.includes(cancel.id)
                    ? "2px solid #005CA9"
                    : "1px solid #ccc",
                  cursor: "pointer",
                  width: "90%",
                }}
              >
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <SelectionIndicator
                    selected={selectedCards.includes(cancel.id)}
                  />
                  <LeftContent>
                    <h2>{cancel.associadoNome}</h2>
                    <h2>Plano: {cancel.categoria}</h2>
                  </LeftContent>
                </div>
              </CancelCard>
            ))
          ) : hasSearched && !loading ? (
            <p style={{ marginTop: "20px", color: "#777", fontSize: "20px" }}>
              Planos não encontrados.
            </p>
          ) : null}
        </WrapCards>
        <DeactivateButton2 onClick={handleDeactivate}>
          Desativar selecionados
        </DeactivateButton2>
      </WrapContent>
    </CancelPlanStyle>
  );
}
